import http from '@/services/api/http';

export default {
  getMarket(marketId, commentThreadId = '') {
    if (commentThreadId) {
      return http.get(`api/Market/${marketId}?commentThreadId=${commentThreadId}`);
    }
    return http.get(`api/Market/${marketId}`);
  },
  getCommentThread({ marketId, threadId }) {
    return http.get(`api/Market/${marketId}/CommentThread/${threadId}`);
  },
  getMarketRules(marketId) {
    return http.get(`api/Market/${marketId}/Rule`);
  },
  getContract(contractId) {
    return http.get(`api/Market/Contract/${contractId}`);
  },
  getMarketContracts(marketId) {
    return http.get(`api/Market/${marketId}/Contracts`);
  },
  getMarketContractsStats(marketId) {
    return http.get(`api/Market/${marketId}/Contracts/Stats`);
  },
  getMarketRelated(marketId) {
    return http.get(`api/Market/${marketId}/Related`);
  },
};



// WEBPACK FOOTER //
// ./src/services/api/market.js